import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950" role="contentinfo">
      <div className="px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4" aria-label={siteInfo.name}>
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                  {siteInfo.name}
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                免费韩漫在线阅读平台，汇集好看的韩国漫画和韩国漫画大全，为您提供流畅的阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-secondary-300 mb-4">
                快速链接
              </h4>
              <nav className="flex flex-col gap-2" aria-label="页脚导航">
                <Link to="/" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  首页
                </Link>
                <Link to="/category/romance" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  漫画分类
                </Link>
                <Link to="/about" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
                <Link to="/about" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  联系我们
                </Link>
              </nav>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-secondary-300 mb-4">
                热门分类
              </h4>
              <nav className="flex flex-col gap-2" aria-label="分类导航">
                <Link to="/category/romance" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  恋爱漫画
                </Link>
                <Link to="/category/fantasy" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  奇幻漫画
                </Link>
                <Link to="/category/action" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  动作漫画
                </Link>
                <Link to="/category/drama" className="text-sm text-secondary-200 hover:text-background-50 transition-colors">
                  剧情漫画
                </Link>
              </nav>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-secondary-300 mb-4">
                关注我们
              </h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="哔哩哔哩" rel="nofollow">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mb-10 overflow-hidden">
            <div className="text-6xl md:text-8xl lg:text-9xl font-black text-secondary-800/40 tracking-tighter select-none whitespace-nowrap">
              QIMIAOMANHUA
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-secondary-800/50 gap-3">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}